import axios from 'axios'
import { API_ENDPOINT } from '../../../config'
import store from '../../../redux/stores/store'

const getDefaultState = () => {
    return {
        loading: false,
        deletingId: null,
        visaPackages: [],
        filter: {
            column: "",
            value: ""
        },
        selectedIndex: -1,
        currentPage: 1,
        pageSize: 50,
        total: 0
    }
}

const loadVisaPackages = instance => {
    instance.setState({ ...instance.state, loading: true })

    let criteria = {}
    if (instance.state.filter.column.length > 0 && instance.state.filter.value.length > 0) {
        criteria = {
            [instance.state.filter.column]: instance.state.filter.value
        }
    }

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/visa-packages",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            offset: (instance.state.currentPage - 1) * instance.state.pageSize,
            limit: instance.state.pageSize,
            criteria: criteria
        }
    }).then(response => handleLoadVisaPackagesResponse(instance, response))
    .catch(error => alert(error))
}

const handleLoadVisaPackagesResponse = (instance, response) => {
    if (response.status === 200 && response.data.status === 200) {
        const visaPackages = response.data.data.visaPackages || response.data.data.packages || response.data.data.items || []
        instance.setState({
            ...instance.state,
            loading: false,
            visaPackages: visaPackages
        })
    }
    else if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
    }
}

const VisaPackagesWorker = instance => {
    const deleteVisaPackage = id => {
        instance.setState({ ...instance.state, deletingId: id })
        axios({
            method: 'post',
            url: API_ENDPOINT + "/api/visa-package/delete",
            headers: {
                "Authorization": store.getState().auth.authorization
            },
            data: {
                id: id
            }
        }).then(response => handleDeleteVisaPackageResponse(instance, response, id))
        .catch(error => alert(error))
    }

    const handleDeleteVisaPackageResponse = (instance, response, id) => {
        if (response.status === 200 && response.data.status === 200) {
            instance.setState({
                ...instance.state,
                deletingId: null,
                visaPackages: instance.state.visaPackages.filter((visaPackage) => visaPackage.id !== id)
            })
        }
        else if (response.data.status === 403) {
            instance.props.history.push('/auth/login')
        }
        else {
            instance.setState({
                ...instance.state,
                deletingId: null
            })
        }
    }

    return {
        loadVisaPackages: () => loadVisaPackages(instance),
        getDefaultState: () => getDefaultState(instance),
        deleteVisaPackage: (id) => deleteVisaPackage(id)
    }
}

export default VisaPackagesWorker
